import React from 'react';

function ToolSelector({ setSelectedTool }) {
    const handleToolChange = (tool) => {
        setSelectedTool(tool);
    };

    return (
        <>
        <div className="mx-auto max-w-lg text-center lg:max-w-4xl">
        <p className="mt-2 text-xl font-bold text-gray-900">I want an email to send to...</p>
        <button 
          className="w-full mx-auto bg-white shadow-2xl max-w-4xl mt-8 p-5 sm:p-10 text-2xl"
          onClick={() => handleToolChange('linkedin-voice')}
        >
            a <b>single</b> prospect 👨🏻‍💼 <br />
            <span className='text-sm'>(I have their LinkedIn URL)</span>
        </button>
        <button 
          className="w-full mx-auto bg-white shadow-2xl max-w-4xl mt-8 p-5 sm:p-10 text-2xl"
          onClick={() => handleToolChange('generic-voice')}
        >
            <b>many</b> prospects 🧑🏽‍💼👨🏼‍💼👩🏻‍💼👨🏾‍💼🐕
        </button>
        </div>
        </>
    );
}

export default ToolSelector;